<section class="risk-selection-section">
  <div class="container">
    <!-- Header -->
    <div class="section-header">
      <h1 class="section-title">{{ "page.risks.title" | translate }}</h1>
      <p class="section-subtitle">{{ "page.risks.description" | translate }}</p>
    </div>

    <!-- Loading -->
    <div *ngIf="dataSource.loading$ | async" class="loading-container">
      <mat-spinner></mat-spinner>
      <p>{{ "common.loading" | translate }}</p>
    </div>

    <!-- Empty state -->
    <div class="section-subheader" *ngIf="(dataSource.loading$ | async) === false && dataSource.getData().length === 0">
      <h2 class="section-subtitle">{{ "page.risks.empty" | translate }}</h2>
    </div>

    <!-- Search on tags -->
    <app-search-risk-tags
      *ngIf="(dataSource.loading$ | async) === false && dataSource.getData().length > 0"
      [selectedTags]="filters.tags ?? []"
      (selectedTagsChange)="onTagsChanged($event)"
    ></app-search-risk-tags>

    <!-- Risk Cards Grid -->
    <div class="risk-cards-grid" *ngIf="(dataSource.loading$ | async) === false && dataSource.getData().length > 0">
      <div
        *ngFor="let risk of dataSource.getData()"
        class="risk-card"
        role="button"
        tabindex="0"
        (click)="goToRisk(risk.identifier.value)"
        (keydown.enter)="goToRisk(risk.identifier.value)"
        (keydown.space)="goToRisk(risk.identifier.value)"
      >
        <h3 class="risk-card-title">{{ risk.title }}</h3>
        <p class="risk-card-description">{{ risk.description }}</p>
        <div class="card-actions">
          <button
            *ngIf="risk.questionnaires.length"
            class="btn-primary"
            [routerLink]="['/risks', risk.identifier.value, 'questionnaires', risk.questionnaires[0]]"
            [state]="{ allQuestionnaires: risk.questionnaires }"
            (click)="$event.stopPropagation()"
          >
            {{ "button.startQuestionnaire" | translate }}
          </button>
          <button class="btn-link" [routerLink]="['/risks', risk.identifier.value]" (click)="$event.stopPropagation()">
            {{ "button.learnMore" | translate }} →
          </button>
        </div>
      </div>
    </div>
  </div>

  <!-- Paginator -->
  <mat-paginator
    [hidden]="(dataSource.loading$ | async) || dataSource.getData().length === 0"
    [length]="totalCount"
    [pageSize]="filters.pageSize ?? 10"
    [pageSizeOptions]="pageSizeOptions"
    [pageIndex]="(filters.page ?? 1) - 1"
    [showFirstLastButtons]="true"
    class="risks-paginator"
    aria-label="Select page"
  ></mat-paginator>

  <!-- Info Box -->
  <div class="info-box" *ngIf="(dataSource.loading$ | async) === false && dataSource.getData().length > 0">
    <div class="info-icon">💡</div>
    <div class="info-content">
      <h4>{{ "page.risks.infoBox.title" | translate }}</h4>
      <p>{{ "page.risks.infoBox.description" | translate }}</p>
    </div>
  </div>
</section>
